import {k} from './kaplay.js'

k.loadRoot("./"); // A good idea for Itch.io publishing later

k.loadMusic("bgm", "sounds/bgm.ogg")
k.loadSound("excellent", "sounds/excellent.ogg")
k.loadSound("pretty_good", "sounds/pretty_good.ogg")
k.loadSound("too_bad", "sounds/too_bad.ogg")
k.loadSound("scroll", "sounds/scroll.ogg")
k.loadSound("click", "sounds/click.ogg")

k.loadFont("regular", "fonts/Nunito-Regular.ttf")
k.loadFont("bold", "fonts/Nunito-Bold.ttf")
k.loadFont("black", "fonts/Nunito-Black.ttf")

k.loadSprite("logo", "sprites/logo.png");
k.loadSprite("title", "sprites/title.png")
k.loadSprite("table", "sprites/table.png")

k.loadSprite("bottle", "sprites/bottle.png")
k.loadSprite("bottle_shadow", "sprites/bottle_shadow.png")

k.loadSprite("button", "sprites/button.png", {
  slice9: {
    left: 55,
    top: 55,
    right: 55,
    bottom: 55,
    tileMode: "center"
  }
})
k.loadSprite("button_secondary", "sprites/button_secondary.png", {
  slice9: {
    left: 55,
    top: 55,
    right: 55,
    bottom: 55,
    tileMode: "center"
  }
})
k.loadSprite("panel", "sprites/panel.png", {
  slice9: {
    left: 55,
    top: 55,
    right: 55,
    bottom: 55,
    tileMode: "center"
  }
})

k.loadSprite("progress_frame", "sprites/progress_frame.png")
k.loadSprite("progress_indicator", "sprites/progress_indicator.png")
k.loadSprite("progress_range", "sprites/progress_range.png")

k.loadSprite("sugar_slider_rail", "sprites/sugar_slider_rail.png")
k.loadSprite("slider_stevia", "sprites/sugar_slider_stevia.png")
k.loadSprite("slider_eryth", "sprites/sugar_slider_eryth.png")
k.loadSprite("slider_inulin", "sprites/sugar_slider_inulin.png")
